import { useState, useEffect } from 'react';
import { Row, Col, Button, Form, Dropdown, Badge, Table } from 'react-bootstrap';
import Select from 'react-select';
import FilterProjectFilesOffcanvas from './ProjectFilesFilter';
import { UploadFileModal, FilePreviewModal, RenameFileModal, MoveFileModal } from './ProjectFilesModals';
import './ProjectFiles.css';

const ProjectFiles = ({ projectId, projectName }) => {
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showFilterOffcanvas, setShowFilterOffcanvas] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [showMoveModal, setShowMoveModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');
    const [files, setFiles] = useState([]);
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
    
    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);

    // Upload Form State
    const [uploadFile, setUploadFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [fileCategory, setFileCategory] = useState(null);
    const [fileDescription, setFileDescription] = useState('');

    // Filter State
    const [filterKeywords, setFilterKeywords] = useState('');
    const [filterCategories, setFilterCategories] = useState(null);
    const [filterUploadedBy, setFilterUploadedBy] = useState(null);
    const [filterStartDate, setFilterStartDate] = useState(null);
    const [filterEndDate, setFilterEndDate] = useState(null);

    // Mock data
    const categoryOptions = [
        { value: 'design', label: 'Design', color: '#8b5cf6', icon: 'fa-palette' },
        { value: 'development', label: 'Development', color: '#3b82f6', icon: 'fa-code' },
        { value: 'documents', label: 'Documents', color: '#10b981', icon: 'fa-file-alt' },
        { value: 'assets', label: 'Assets', color: '#f59e0b', icon: 'fa-images' },
        { value: 'other', label: 'Other', color: '#6b7280', icon: 'fa-folder' }
    ];

    const mockFiles = [
        { id: 1, name: 'Homepage Mockup.fig', size: '2.4 MB', type: 'figma', category: 'design', uploadedBy: 'Sarah Wilson', uploadedDate: '2024-12-01', description: 'Final homepage design mockup with all sections' },
        { id: 2, name: 'API Documentation.pdf', size: '1.8 MB', type: 'pdf', category: 'documents', uploadedBy: 'John Doe', uploadedDate: '2024-11-30', description: 'Complete API documentation for backend services' },
        { id: 3, name: 'database-schema.sql', size: '45 KB', type: 'code', category: 'development', uploadedBy: 'Mike Johnson', uploadedDate: '2024-11-29', description: 'Database schema and initial migration' },
        { id: 4, name: 'Logo Assets.zip', size: '3.2 MB', type: 'zip', category: 'assets', uploadedBy: 'Sarah Wilson', uploadedDate: '2024-11-28', description: 'Brand logo in multiple formats and sizes' },
        { id: 5, name: 'Project Requirements.docx', size: '890 KB', type: 'word', category: 'documents', uploadedBy: 'John Doe', uploadedDate: '2024-11-27', description: 'Detailed project requirements and specifications' },
        { id: 6, name: 'Wireframes.sketch', size: '4.1 MB', type: 'sketch', category: 'design', uploadedBy: 'Emily Davis', uploadedDate: '2024-11-26', description: 'Initial wireframes for all pages' },
        { id: 7, name: 'User Flow Diagram.svg', size: '156 KB', type: 'svg', category: 'design', uploadedBy: 'David Brown', uploadedDate: '2024-11-25', description: 'Complete user journey and flow diagram' },
        { id: 8, name: 'Budget Breakdown.xlsx', size: '234 KB', type: 'excel', category: 'documents', uploadedBy: 'John Doe', uploadedDate: '2024-11-24', description: 'Detailed budget allocation and timeline' },
        { id: 9, name: 'auth-module.js', size: '18 KB', type: 'code', category: 'development', uploadedBy: 'Mike Johnson', uploadedDate: '2024-11-23', description: 'Authentication and authorization module' },
        { id: 10, name: 'Product Images.zip', size: '8.7 MB', type: 'zip', category: 'assets', uploadedBy: 'Sarah Wilson', uploadedDate: '2024-11-22', description: 'High-resolution product images' },
        { id: 11, name: 'Meeting Notes.pdf', size: '412 KB', type: 'pdf', category: 'documents', uploadedBy: 'Emily Davis', uploadedDate: '2024-11-21', description: 'Notes from client meeting' },
        { id: 12, name: 'Demo Video.mp4', size: '15.3 MB', type: 'video', category: 'other', uploadedBy: 'David Brown', uploadedDate: '2024-11-20', description: 'Project demo and walkthrough video' },
        { id: 13, name: 'Homepage Mockup.fig', size: '2.4 MB', type: 'figma', category: 'design', uploadedBy: 'Sarah Wilson', uploadedDate: '2024-12-01', description: 'Final homepage design mockup with all sections' },
        { id: 14, name: 'API Documentation.pdf', size: '1.8 MB', type: 'pdf', category: 'documents', uploadedBy: 'John Doe', uploadedDate: '2024-11-30', description: 'Complete API documentation for backend services' },
        { id: 15, name: 'database-schema.sql', size: '45 KB', type: 'code', category: 'development', uploadedBy: 'Mike Johnson', uploadedDate: '2024-11-29', description: 'Database schema and initial migration' },
        { id: 16, name: 'Logo Assets.zip', size: '3.2 MB', type: 'zip', category: 'assets', uploadedBy: 'Sarah Wilson', uploadedDate: '2024-11-28', description: 'Brand logo in multiple formats and sizes' },
        { id: 17, name: 'Project Requirements.docx', size: '890 KB', type: 'word', category: 'documents', uploadedBy: 'John Doe', uploadedDate: '2024-11-27', description: 'Detailed project requirements and specifications' },
        { id: 18, name: 'Wireframes.sketch', size: '4.1 MB', type: 'sketch', category: 'design', uploadedBy: 'Emily Davis', uploadedDate: '2024-11-26', description: 'Initial wireframes for all pages' },
        { id: 19, name: 'User Flow Diagram.svg', size: '156 KB', type: 'svg', category: 'design', uploadedBy: 'David Brown', uploadedDate: '2024-11-25', description: 'Complete user journey and flow diagram' },
        { id: 20, name: 'Budget Breakdown.xlsx', size: '234 KB', type: 'excel', category: 'documents', uploadedBy: 'John Doe', uploadedDate: '2024-11-24', description: 'Detailed budget allocation and timeline' },
        { id: 21, name: 'auth-module.js', size: '18 KB', type: 'code', category: 'development', uploadedBy: 'Mike Johnson', uploadedDate: '2024-11-23', description: 'Authentication and authorization module' },
        { id: 22, name: 'Product Images.zip', size: '8.7 MB', type: 'zip', category: 'assets', uploadedBy: 'Sarah Wilson', uploadedDate: '2024-11-22', description: 'High-resolution product images' },
        { id: 23, name: 'Meeting Notes.pdf', size: '412 KB', type: 'pdf', category: 'documents', uploadedBy: 'Emily Davis', uploadedDate: '2024-11-21', description: 'Notes from client meeting' },
        { id: 24, name: 'Demo Video.mp4', size: '15.3 MB', type: 'video', category: 'other', uploadedBy: 'David Brown', uploadedDate: '2024-11-20', description: 'Project demo and walkthrough video' }
    ];

    const teamMembers = [
        { value: 'john', label: 'John Doe' },
        { value: 'sarah', label: 'Sarah Wilson' },
        { value: 'mike', label: 'Mike Johnson' },
        { value: 'emily', label: 'Emily Davis' },
        { value: 'david', label: 'David Brown' }
    ];

    // Mock folder structure
    const mockFolders = [
        { id: 1, name: 'Root', path: '/', parentId: null },
        { id: 2, name: 'Design Files', path: '/Design Files', parentId: 1 },
        { id: 3, name: 'Documents', path: '/Documents', parentId: 1 },
        { id: 4, name: 'Development', path: '/Development', parentId: 1 },
        { id: 5, name: 'Assets', path: '/Assets', parentId: 1 },
        { id: 6, name: 'Archives', path: '/Archives', parentId: 1 },
        { id: 7, name: 'UI Mockups', path: '/Design Files/UI Mockups', parentId: 2 },
        { id: 8, name: 'Wireframes', path: '/Design Files/Wireframes', parentId: 2 },
        { id: 9, name: 'Legal', path: '/Documents/Legal', parentId: 3 },
        { id: 10, name: 'Reports', path: '/Documents/Reports', parentId: 3 }
    ];

    const currentFolder = { id: 1, name: 'Root', path: '/' };

    // Initialize files state on component mount
    useEffect(() => {
        setFiles(mockFiles.map(file => ({ ...file, folderId: 1 }))); // All files in Root initially
    }, []);

    // Show toast notification
    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
        setTimeout(() => {
            setToast({ show: false, message: '', type: 'success' });
        }, 3000);
    };

    // Calculations
    const getFilteredFiles = () => {
        const filesToFilter = files.length > 0 ? files : mockFiles;
        return filesToFilter.filter(file => {
            const matchesCategory = selectedCategory === 'all' || file.category === selectedCategory;
            const matchesSearch = file.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                file.description.toLowerCase().includes(searchQuery.toLowerCase());
            return matchesCategory && matchesSearch;
        });
    };

    const filesToUse = files.length > 0 ? files : mockFiles;
    const totalFiles = filesToUse.length;
    const totalSize = filesToUse.reduce((acc, file) => {
        const size = parseFloat(file.size);
        const unit = file.size.includes('MB') ? 1 : 0.001;
        return acc + (size * unit);
    }, 0).toFixed(1);

    const categoryCounts = categoryOptions.map(cat => ({
        ...cat,
        count: filesToUse.filter(f => f.category === cat.value).length
    }));

    const lastUploadedFile = filesToUse[0];

    const getFileIcon = (fileType) => {
        const icons = {
            'figma': { icon: 'fab fa-figma', color: '#F24E1E' },
            'sketch': { icon: 'fas fa-pencil-ruler', color: '#F7B500' },
            'pdf': { icon: 'fas fa-file-pdf', color: '#dc2626' },
            'word': { icon: 'fas fa-file-word', color: '#2563eb' },
            'excel': { icon: 'fas fa-file-excel', color: '#16a34a' },
            'zip': { icon: 'fas fa-file-archive', color: '#f59e0b' },
            'code': { icon: 'fas fa-file-code', color: '#8b5cf6' },
            'svg': { icon: 'fas fa-file-image', color: '#06b6d4' },
            'video': { icon: 'fas fa-file-video', color: '#ec4899' },
            'figma': { icon: 'fab fa-figma', color: '#F24E1E' },
            'sketch': { icon: 'fas fa-pencil-ruler', color: '#F7B500' },
            'pdf': { icon: 'fas fa-file-pdf', color: '#dc2626' },
            'word': { icon: 'fas fa-file-word', color: '#2563eb' },
            'excel': { icon: 'fas fa-file-excel', color: '#16a34a' },
            'zip': { icon: 'fas fa-file-archive', color: '#f59e0b' },
            'code': { icon: 'fas fa-file-code', color: '#8b5cf6' },
            'svg': { icon: 'fas fa-file-image', color: '#06b6d4' },
            'video': { icon: 'fas fa-file-video', color: '#ec4899' },
            'image': { icon: 'fas fa-file-image', color: '#10b981' }
        };
        return icons[fileType] || { icon: 'fas fa-file', color: '#6b7280' };
    };

    const getCategoryColor = (category) => {
        const cat = categoryOptions.find(c => c.value === category);
        return cat ? cat.color : '#6b7280';
    };

    const getCategoryIcon = (category) => {
        const cat = categoryOptions.find(c => c.value === category);
        return cat ? cat.icon : 'fa-folder';
    };

    const handleUploadFile = () => {
        // TODO: Implement file upload API call
        console.log('Uploading file:', { uploadFile, fileName, fileCategory, fileDescription });
        setShowUploadModal(false);
        resetUploadForm();
    };

    const resetUploadForm = () => {
        setUploadFile(null);
        setFileName('');
        setFileCategory(null);
        setFileDescription('');
    };

    const handleApplyFilters = () => {
        // TODO: Apply filters
        console.log('Applying filters:', { filterKeywords, filterCategories, filterUploadedBy, filterStartDate, filterEndDate });
        setShowFilterOffcanvas(false);
    };

    const handleResetFilters = () => {
        setFilterKeywords('');
        setFilterCategories(null);
        setFilterUploadedBy(null);
        setFilterStartDate(null);
        setFilterEndDate(null);
    };

    const handleFilePreview = (file) => {
        setSelectedFile(file);
        setShowPreviewModal(true);
    };

    const handleFileAction = (action, file) => {
        setSelectedFile(file);
        
        switch (action) {
            case 'rename':
                setShowRenameModal(true);
                break;
            case 'move':
                setSelectedFiles([file]);
                setShowMoveModal(true);
                break;
            case 'download':
                console.log('Downloading file:', file.name);
                showToast(`Downloading ${file.name}...`, 'info');
                break;
            case 'delete':
                console.log('Delete file:', file.name);
                // TODO: Implement delete confirmation
                break;
            default:
                console.log('File action:', action, file);
        }
    };

    // Handle rename file
    const handleRenameFile = (fileId, newName) => {
        setFiles(prevFiles => {
            const updatedFiles = prevFiles.map(file =>
                file.id === fileId ? { ...file, name: newName } : file
            );
            return updatedFiles;
        });
        showToast('File renamed successfully', 'success');
        setShowRenameModal(false);
        setSelectedFile(null);
    };

    // Handle move files
    const handleMoveFiles = (fileIds, targetFolderId) => {
        setFiles(prevFiles => {
            const updatedFiles = prevFiles.map(file =>
                fileIds.includes(file.id) ? { ...file, folderId: targetFolderId } : file
            );
            return updatedFiles;
        });
        
        const fileCount = fileIds.length;
        const message = fileCount === 1 ? 'File moved successfully' : `${fileCount} files moved successfully`;
        showToast(message, 'success');
        setShowMoveModal(false);
        setSelectedFiles([]);
    };

    const filteredFiles = getFilteredFiles();

    // Pagination Calculations
    const totalPages = Math.ceil(filteredFiles.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedFiles = filteredFiles.slice(startIndex, endIndex);

    return (
        <>
            {/* File Summary Stats */}
            <Row className="g-4 mb-4">
                <Col lg={3} md={6}>
                    <div className="bg-white border rounded-3 p-3 h-100 file-stat-card-hover">
                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary flex-shrink-0 rounded-3 icon-box-48">
                                <i className="fas fa-folder-open"></i>
                            </div>
                            <div className="flex-grow-1">
                                <div className="text-primary fw-bold mb-1" style={{ fontSize: '20px', lineHeight: '1' }}>{totalFiles}</div>
                                <div className="text-secondary small">Total Files</div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={3} md={6}>
                    <div className="bg-white border rounded-3 p-3 h-100 file-stat-card-hover">
                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center justify-content-center bg-success bg-opacity-10 text-success flex-shrink-0 rounded-3 icon-box-48">
                                <i className="fas fa-database"></i>
                            </div>
                            <div className="flex-grow-1">
                                <div className="text-success fw-bold mb-1" style={{ fontSize: '20px', lineHeight: '1' }}>{totalSize} MB</div>
                                <div className="text-secondary small">Total Size</div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={3} md={6}>
                    <div className="bg-white border rounded-3 p-3 h-100 file-stat-card-hover">
                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center justify-content-center bg-warning bg-opacity-10 text-warning flex-shrink-0 rounded-3 icon-box-48">
                                <i className="fas fa-clock"></i>
                            </div>
                            <div className="flex-grow-1 min-w-0">
                                <div className="text-warning fw-bold mb-1 text-truncate" style={{ fontSize: '14px', lineHeight: '1.2' }}>{lastUploadedFile.name}</div>
                                <div className="text-secondary small">Last Uploaded</div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={3} md={6}>
                    <div className="bg-white border rounded-3 p-3 h-100 file-stat-card-hover">
                        <div>
                            <div className="text-secondary small mb-2">Files by Category</div>
                            <div className="d-flex flex-wrap gap-2">
                                {categoryCounts.slice(0, 3).map(cat => (
                                    <Badge
                                        key={cat.value}
                                        bg="light"
                                        text="dark"
                                        className="border category-badge-sm"
                                        style={{ borderColor: cat.color, fontSize: '0.7rem' }}
                                    >
                                        {cat.label}: {cat.count}
                                    </Badge>
                                ))}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Main Files Section */}
            <div className="c-card-1">
                <div className="c-card-header-1">
                    <div className="d-flex justify-content-between align-items-center w-100 flex-wrap gap-3">
                        {/* Left Section - Title */}
                        <div>
                            <div className="mb-0 fw-semibold"> Files for {projectName} </div>
                        </div>

                        {/* Right Section - Controls */}
                        <div className="d-flex align-items-center gap-3 flex-wrap">
                            {/* Category Filter */}
                            <Dropdown className='c-dropdown-1'>
                                <Dropdown.Toggle variant='link' className='border rounded-1 px-3 py-2 bg-transparent text-decoration-none'>
                                    <i className="fas fa-layer-group me-2"></i>
                                    {selectedCategory === 'all' ? 'All Categories' : categoryOptions.find(c => c.value === selectedCategory)?.label}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => setSelectedCategory('all')}
                                        active={selectedCategory === 'all'}
                                    >
                                        <i className="fas fa-folder me-2"></i>
                                        All Categories
                                    </Dropdown.Item>
                                    {categoryOptions.map(cat => (
                                        <Dropdown.Item
                                            key={cat.value}
                                            onClick={() => setSelectedCategory(cat.value)}
                                            active={selectedCategory === cat.value}
                                        >
                                            <i className={`fas ${cat.icon} me-2`} style={{ color: cat.color }}></i>
                                            {cat.label}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* Search Box */}
                            <div className="position-relative">
                                <div className="files-search-wrapper d-flex align-items-center">
                                    <i className="fas fa-search files-search-icon" aria-hidden="true"></i>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search files..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="files-search-input"
                                        aria-label="Search files"
                                    />
                                    {searchQuery && (
                                        <button
                                            type="button"
                                            className="files-search-clear"
                                            onClick={() => setSearchQuery('')}
                                            aria-label="Clear search"
                                            title="Clear search"
                                        >
                                            <i className="fas fa-times" aria-hidden="true"></i>
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* View Mode Toggle */}
                            <div className="files-view-toggle d-flex gap-0 p-1">
                                <Button
                                    variant={viewMode === 'grid' ? 'primary' : 'light'}
                                    className={`files-view-btn d-flex align-items-center justify-content-center p-0 ${viewMode === 'grid' ? 'active' : ''}`}
                                    onClick={() => setViewMode('grid')}
                                    title="Grid View"
                                >
                                    <i className="fas fa-th"></i>
                                </Button>
                                <Button
                                    variant={viewMode === 'list' ? 'primary' : 'light'}
                                    className={`files-view-btn d-flex align-items-center justify-content-center p-0 ${viewMode === 'list' ? 'active' : ''}`}
                                    onClick={() => setViewMode('list')}
                                    title="List View"
                                >
                                    <i className="fas fa-list"></i>
                                </Button>
                            </div>

                            {/* Advanced Filter Button */}
                            <Button
                                variant="outline-primary"
                                onClick={() => setShowFilterOffcanvas(true)}
                                title="Advanced Filters"
                            >
                                <i className="fas fa-filter me-2"></i>
                                Filters
                            </Button>

                            {/* Upload Button */}
                            <Button
                                variant="primary"
                                className="files-upload-btn text-nowrap"
                                onClick={() => setShowUploadModal(true)}
                            >
                                <i className="fas fa-cloud-upload-alt me-2"></i>
                                Upload
                            </Button>
                        </div> 
                    </div>
                </div>

                <div className={`c-card-body-1 ${viewMode === 'list' ? ' p-0' : ''}`}>
                    {filteredFiles.length === 0 ? (
                        <div className="files-empty-state text-center py-5 px-4">
                            <i className="fas fa-folder-open mb-4"></i>
                            <h5 className="mb-2 fs-18">No Files Found</h5>
                            <p className="text-muted mb-3 fs-14">
                                {searchQuery || selectedCategory !== 'all'
                                    ? 'Try adjusting your filters or search query'
                                    : 'Upload your first file to get started'}
                            </p>
                            {!searchQuery && selectedCategory === 'all' && (
                                <Button variant="primary" onClick={() => setShowUploadModal(true)}>
                                    <i className="fas fa-upload me-2"></i>Upload File
                                </Button>
                            )}
                        </div>
                    ) : (
                        <>
                            {/* Grid View */}
                            {viewMode === 'grid' && (
                                <Row className="g-3">
                                    {paginatedFiles.map(file => {
                                        const fileIcon = getFileIcon(file.type);
                                        return (
                                            <Col key={file.id} xs={6} sm={4} md={3} lg={2}>
                                                <div
                                                    className="premium-file-card"
                                                    onClick={() => handleFilePreview(file)}
                                                >
                                                    {/* Action Dropdown - Top Right */}
                                                    <div className="premium-file-action">
                                                        <Dropdown className='c-dropdown-1' onClick={(e) => e.stopPropagation()}>
                                                            <Dropdown.Toggle variant="link">
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu align="end">
                                                                <Dropdown.Item onClick={() => handleFilePreview(file)}>
                                                                    <i className="fas fa-eye me-2"></i> Preview
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('download', file)}>
                                                                    <i className="fas fa-download me-2"></i> Download
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('rename', file)}>
                                                                    <i className="fas fa-edit me-2"></i> Rename
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('move', file)}>
                                                                    <i className="fas fa-folder me-2"></i> Move
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('delete', file)}>
                                                                    <i className="fas fa-trash me-2"></i> Delete
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>

                                                    {/* File Icon Section with Badge */}
                                                    <div className="premium-file-icon-section d-flex flex-column align-items-center p-3">
                                                        <div
                                                            className="premium-file-icon-wrapper d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: `${fileIcon.color}10`,
                                                                borderColor: `${fileIcon.color}25`
                                                            }}
                                                        >
                                                            <i
                                                                className={`fas ${getCategoryIcon(file.category)}`}
                                                                style={{ color: fileIcon.color, fontSize: '1.7rem' }}
                                                            ></i>
                                                        </div>
                                                        <div className='file-name fs-14 mt-3'> {categoryOptions.find(c => c.value === file.category)?.label} </div>
                                                    </div>

                                                    {/* File Content Section */}
                                                    <div className="premium-file-content p-3">
                                                        <h6 className="premium-file-name fs-14" title={file.name}>
                                                            {file.name}
                                                        </h6>

                                                        {/* File Meta Info Row */}
                                                        <div className="premium-file-meta fs-12 d-flex align-items-center gap-2">
                                                            <span className="premium-file-size">
                                                                {file.size}
                                                            </span>
                                                            <span className="premium-file-divider">•</span>
                                                            <span className="premium-file-date">
                                                                {file.uploadedDate}
                                                            </span>
                                                        </div>

                                                        {/* File Footer - Uploader with User Icon */}
                                                        <div className="premium-file-footer mt-2 pt-2">
                                                            <div className="premium-file-uploader fs-14 d-flex align-items-center gap-1">
                                                                <span>{file.uploadedBy}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            )}

                            {/* List View */}
                            {viewMode === 'list' && (
                                <Table responsive className='c-table'>
                                    <thead>
                                        <tr>
                                            <th width="50px" className='text-center'>
                                                <Form.Check />
                                            </th>
                                            <th>File Name</th>
                                            <th width="150px" className='text-center'>Category</th>
                                            <th width="100px" className='text-center'>Size</th>
                                            <th width="150px" className='text-center'>Uploaded By</th>
                                            <th width="120px" className='text-center'>Date</th>
                                            <th width="80px" className='text-center'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedFiles.map(file => {
                                            const fileIcon = getFileIcon(file.type);
                                            return (
                                                <tr key={file.id} style={{ cursor: 'pointer' }} onClick={() => handleFilePreview(file)}>
                                                    <td className='text-center'>
                                                        <Form.Check onClick={(e) => e.stopPropagation()} />
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <i
                                                                className={`${fileIcon.icon} me-2`}
                                                                style={{ color: fileIcon.color, fontSize: '1.25rem' }}
                                                            ></i>
                                                            <span className="fw-medium">{file.name}</span>
                                                        </div>
                                                    </td>
                                                    <td className='text-center text-muted'> {categoryOptions.find(c => c.value === file.category)?.label} </td> 
                                                    <td className='text-center text-muted'>{file.size}</td>
                                                    <td className='text-center text-muted'>{file.uploadedBy}</td>
                                                    <td className='text-center text-muted'>{file.uploadedDate}</td>
                                                    <td className='text-center'>
                                                        <Dropdown className='c-dropdown-1' onClick={(e) => e.stopPropagation()}>
                                                            <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item onClick={() => handleFilePreview(file)}>
                                                                    <i className="fas fa-eye me-2"></i> Preview
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('download', file)}>
                                                                    <i className="fas fa-download me-2"></i> Download
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('rename', file)}>
                                                                    <i className="fas fa-edit me-2"></i> Rename
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('move', file)}>
                                                                    <i className="fas fa-folder me-2"></i> Move
                                                                </Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleFileAction('delete', file)}>
                                                                    <i className="fas fa-trash me-2"></i> Delete
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            )}
                        </>
                    )}
                </div>
                <div className='c-card-footer-1'>
                    <div className='d-flex justify-content-between align-items-center c-pagination flex-wrap gap-3'>
                        <div className="p-tag d-flex align-items-center text-nowrap">
                            Show
                            <select 
                                className="form-select mx-2" 
                                style={{ minWidth: 70 }}
                                value={itemsPerPage}
                                onChange={(e) => {
                                    setItemsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="6">6</option>
                                <option value="12">12</option>
                                <option value="24">24</option>
                                <option value="48">48</option>
                            </select>
                            per page ({filteredFiles.length} total)
                        </div>
                        <div className='d-flex align-items-center gap-2 p-tag'>
                            <div className='text-nowrap'>
                                {startIndex + 1} to {Math.min(endIndex, filteredFiles.length)} of {filteredFiles.length}
                            </div>
                            <Button 
                                variant="btn"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}
                            >
                                <i className="fas fa-chevron-left"></i>
                            </Button>
                            <select 
                                className='form-select' 
                                style={{ minWidth: 70 }}
                                value={currentPage}
                                onChange={(e) => setCurrentPage(Number(e.target.value))}
                            >
                                {[...Array(totalPages)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>
                            <Button 
                                variant="btn"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}
                            >
                                <i className="fas fa-chevron-right"></i>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Upload Modal */}
            <UploadFileModal
                show={showUploadModal}
                onHide={() => setShowUploadModal(false)}
                uploadFile={uploadFile}
                setUploadFile={setUploadFile}
                fileName={fileName}
                setFileName={setFileName}
                fileCategory={fileCategory}
                setFileCategory={setFileCategory}
                fileDescription={fileDescription}
                setFileDescription={setFileDescription}
                categoryOptions={categoryOptions}
                onSubmit={handleUploadFile}
            />

            {/* Filter Offcanvas */}
            <FilterProjectFilesOffcanvas
                show={showFilterOffcanvas}
                onHide={() => setShowFilterOffcanvas(false)}
                filterKeywords={filterKeywords}
                setFilterKeywords={setFilterKeywords}
                filterCategories={filterCategories}
                setFilterCategories={setFilterCategories}
                filterUploadedBy={filterUploadedBy}
                setFilterUploadedBy={setFilterUploadedBy}
                filterStartDate={filterStartDate}
                setFilterStartDate={setFilterStartDate}
                filterEndDate={filterEndDate}
                setFilterEndDate={setFilterEndDate}
                categoryOptions={categoryOptions}
                teamMembers={teamMembers}
                onApply={handleApplyFilters}
                onClear={handleResetFilters}
            />

            {/* File Preview Modal */}
            <FilePreviewModal
                show={showPreviewModal}
                onHide={() => setShowPreviewModal(false)}
                selectedFile={selectedFile}
                categoryOptions={categoryOptions}
                getFileIcon={getFileIcon}
                getCategoryColor={getCategoryColor}
                onFileAction={handleFileAction}
            />

            {/* Rename File Modal */}
            <RenameFileModal
                show={showRenameModal}
                onHide={() => {
                    setShowRenameModal(false);
                    setSelectedFile(null);
                }}
                file={selectedFile}
                allFiles={files.length > 0 ? files : mockFiles}
                onRename={handleRenameFile}
            />

            {/* Move File Modal */}
            <MoveFileModal
                show={showMoveModal}
                onHide={() => {
                    setShowMoveModal(false);
                    setSelectedFiles([]);
                }}
                selectedFiles={selectedFiles}
                allFiles={files.length > 0 ? files : mockFiles}
                folders={mockFolders}
                currentFolder={currentFolder}
                onMove={handleMoveFiles}
            />

            {/* Toast Notification */}
            {toast.show && (
                <div 
                    className="position-fixed top-0 end-0 p-3" 
                    style={{ zIndex: 9999, marginTop: '60px' }}
                >
                    <div className={`alert alert-${toast.type === 'success' ? 'success' : toast.type === 'info' ? 'info' : 'danger'} alert-dismissible fade show`} role="alert">
                        <i className={`fas ${toast.type === 'success' ? 'fa-check-circle' : toast.type === 'info' ? 'fa-info-circle' : 'fa-exclamation-circle'} me-2`}></i>
                        {toast.message}
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={() => setToast({ show: false, message: '', type: 'success' })}
                        ></button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ProjectFiles;
